<template>
    <!-- 新建工单 -->
    <div class="rzy-page">
        <div class="rzy-top-bar">
            <el-button type="primary" @click="creatWarehouse" style="" icon="el-icon-circle-plus">提交</el-button>
        </div>

        <div class="form-wrap">
            <el-card>

                <el-form :model="warehouseInfo" :rules="warehouseRelues" ref="warehouseFormRef" inline size="mini">
                    <el-row>
                        <!-- 第1行 -->
                        <el-col :span="24">
                            <el-form-item label="仓库编码" prop="number">
                                <el-input v-model="warehouseInfo.number" disabled="isDisabled" placeholder="自动生成">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="仓库名称" prop="name">
                                <el-input v-model="warehouseInfo.name" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="允许负库存" prop="XXXXXX">
                                <el-switch v-model="warehouseInfo.enableNegative"> </el-switch>
                            </el-form-item>

                            <el-form-item label="启用仓位" prop="XXXXXX">
                                <el-switch v-model="warehouseInfo.enablePosition"> </el-switch>
                            </el-form-item>

                        </el-col>


                        <!-- 第3行 -->
                        <el-col :span="24">
                            <el-form-item label="仓管员" prop="contact">
                                <el-input v-model="warehouseInfo.contact" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="手机" prop="phone">
                                <el-input v-model="warehouseInfo.phone" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="地址" prop="address">
                                <el-input v-model="warehouseInfo.address" placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <!-- 第4行 -->
                        <el-col :span="24">
                            <el-form-item label="备注" prop="remarks">
                                <el-input v-model="warehouseInfo.remarks" placeholder="请输入" style="width: 800px;"
                                    type="textarea">
                                </el-input>
                            </el-form-item>
                        </el-col>


                    </el-row>
                </el-form>


            </el-card>
        </div>

        <el-row :gutter="10" style="margin-top:10px">
            <el-col :lg="24" :md="24" :sm="24">
                <div class="form-wrap mini auto-width">
                    <div class="toolbar">
                        <div class="col-header">仓位</div>
                        <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="warehouse_addLine()">
                            增行
                        </el-button>
                    </div>
                    <el-table :data="position" class="craft-order" :row-style="{height: '0'}"
                        :header-cell-style="{padding: 0}" border @selection-change="handleSelectionChange">

                        <!-- 选择多行数据时使用 Checkbox。 -->
                        <!--                        <el-table-column type="selection" width="40" align="center">
                        </el-table-column> -->

                        <el-table-column fixed label="行" width="50px" prop="lineNo" align="center" />

                        <el-table-column label="状态" width="100" align="center">
                            <template slot-scope="data">
                                <el-select v-model="data.row.status" placeholder=""
                                    @change="XXXXXX($event, data.row.lineNo)">
                                    <el-option v-for="item in option_status" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column label="仓位编码" width="180" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.number" placeholder="自动生成" disabled="isDisabled"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="仓位名称" width="180" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.name" />
                            </template>
                        </el-table-column>

                        <el-table-column label="对应仓库" width="180" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.warehouseName_backup" disabled="isDisabled"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="备注" width="180" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.remarks" />
                            </template>
                        </el-table-column>
                        <el-table-column label="" width="100" align="center">
                            <template slot-scope="data">
                                <el-button type="primary" size="mini" icon="el-icon-remove"
                                    @click="delDialogOpend(data.row.lineNo)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>


        </el-row>

        <!-- 删除 对话框 -->
        <el-dialog title="删除仓库" :visible.sync="delDialogVisible" width="20%" @close="delDialogClosed">
            <el-form ref="delFormRef" label-width="90px" :model="delForm">
                <el-form-item label="确定删除?">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="delWarehouse">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            // 非负浮点数 检测
            var floatCheck = (rules, value, cb) => {
                const ruler = /^\d+(\.\d+)?$/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入非负浮点数'))
            }


            return {
                // 仓位
                position_index: 1,
                position: [], //用户输入的
                positionKeys: {
                    lineNo: {
                        value: '行',
                        width: 50
                    },
                    status: {
                        value: '状态',
                        width: 50
                    },
                    // number: {
                    //     value: '仓位编码',
                    //     width: 50
                    // },
                    name: {
                        value: '仓位名称',
                        width: 50
                    },
                    remarks: {
                        value: '备注',
                        width: 50
                    },
                },

                // 物料组成
                warehouseZuCheng_index: 1,
                warehouseZuCheng: [],

                warehouseInfo: {
                    name: '', // 名称
                    number: '', // 编号
                    enableNegative: false, //允许负库存
                    enablePosition: true, //启用仓位

                    contact: '',
                    phone: '',
                    address: '',

                    remarks: '', //备注
                },

                warehouseRelues: {
                    name: [{
                        required: true,
                        message: '请输入名称',
                        trigger: 'blur'
                    }],

                    phone: [{
                            required: true,
                            message: '请输入手机号',
                            trigger: 'blur'
                        },
                        {
                            validator: this.$valid.checkPhone,
                            trigger: 'blur'
                        }
                    ]
                },

                multipleSelection: [], //列表选中多行。

                //状态
                option_status: [{
                        label: '停用',
                        value: 0,
                    },
                    {
                        label: '启用',
                        value: 1,
                    },
                ],
            }
        },
        methods: {
            // 外部调用，验证必填的输入框是否都有填写
            getValid() {
                this.$refs.warehouseFormRef.validate(valid => {
                    this.valid = valid
                })
                return this.valid
            },

            //创建 仓库
            creatWarehouse() {
                // 判定数据  是否都填好了
                if (!this.getValid()) {
                    return
                }

                var warehouseOrder = {
                    // createTime: 0  后台创建
                    factoryId: 0,
                    number: this.warehouseInfo.number,
                    name: this.warehouseInfo.name,
                    enableNegative: this.warehouseInfo.enableNegative,
                    enablePosition: this.warehouseInfo.enablePosition,
                    contact: this.warehouseInfo.contact,
                    phone: this.warehouseInfo.phone,
                    address: this.warehouseInfo.address,
                    remarks: this.warehouseInfo.remarks,

                    positionItems: [], //仓位
                }

                // 删除 仓位 中多余的空行.
                warehouseOrder.positionItems = this.clearNullItem(this.position)
                console.log('warehouseOrder.positionItems=', warehouseOrder.positionItems)

                for (let i = 0; i < warehouseOrder.positionItems.length; i++) {
                    if (warehouseOrder.positionItems[i].status === '停用') {
                        warehouseOrder.positionItems[i].status = 0
                    } else {
                        warehouseOrder.positionItems[i].status = 1
                    }
                }

                switch (this.$route.query.type) {
                    case 0: // 新建

                        this.$requestBase({
                            url: 'v1/warehouse/create',
                            method: 'POST',
                            data: warehouseOrder
                        }, true).then(res => {
                            this.$Message.success(res.info)
                            this.$router.push('warehouseConstruction')
                        })
                        break;

                    case 1: // 编辑
                        // 编辑时候，要注意把id 强制追加进去。
                        warehouseOrder.id = this.warehouseInfo.id

                        this.$requestBase({
                            url: 'v1/warehouse/update',
                            method: 'POST',
                            data: warehouseOrder
                        }, true).then(res => {
                            this.$Message.success(res.info)
                            this.$router.push('warehouseConstruction')
                        })

                        break;
                    default:
                        break;
                }


            },

            //仓位--增行
            warehouse_addLine() {
                // console.log('this.position_index = ', this.position_index)
                if (this.position_index >= 11) {
                    this.$Message.closeAll() //防止多条提示
                    this.$Message.success('最多增加10行')
                } else {
                    this.position.push({
                        lineNo: this.position_index,
                        warehouseName_backup: this.warehouseInfo.name
                    })
                    this.position_index++
                }
            },

            // 清空为空的XX对象,只有一个 '行' 的这种
            clearNullItem(Items) {
                const formatItems = []
                Items.forEach(obj => {
                    if (this._.size(obj) <= 1) {
                        return
                    }
                    for (const key in this.positionKeys) {
                        if (this.utils.isEmpty(obj[key])) {
                            obj[key] = ''
                        }
                    }
                    formatItems.push(obj)
                })
                return formatItems
            },

            // 字符串 '2.34512345' 四舍五入成 2位小数=2.35, 再转换成 字符串 '2.35'。注意禁止使用toFixed()。
            // https://wenku.baidu.com/view/a20d74dcadf8941ea76e58fafab069dc50224761.html
            hmjDataChange(inputStr) {
                let data1 = Number(inputStr) // 先转数字
                //Math.round()方法用来把一个数字舍入为最接近的整数
                let data2 = Math.round(data1 * 100) / 100
                return (data2.toString()) //转字符串
            },

            // 根据ID，获取 物料信息
            getWarehouseInfo(type, warehouseId) {
                this.$requestBase({
                    url: 'v1/warehouse/detail',
                    method: 'get',
                    params: {
                        id: warehouseId
                    }
                }).then(res => {
                    res = res.data
                    //this.warehouseInfo = res
                    this.formatResponse(res)
                })
            },


            //格式化 返回结果
            formatResponse(res) {
                //boolean 型切换成 中文显示。
                for (let i = 0; i < res.positionItems.length; i++) {
                    // console.log('i=',i)

                    if (res.positionItems[i].status === 0) {
                        res.positionItems[i].status = '停用'
                    } else {
                        res.positionItems[i].status = '启用'
                    }

                    //编辑时候，初始化 仓位 表。
                    this.position_index = i + 2 //注意，因为初始值为1，表示 下一条 新增的号，所以这里 要 加2。
                    this.position.push({
                        lineNo: i + 1, //因为i从0开始，这里要比 i多1
                        status: res.positionItems[i].status,
                        name: res.positionItems[i].name,
                        remarks: res.positionItems[i].remarks,

                        // hcy: 后台的判断逻辑：有id值-》更新既存的规格，无id值-》新建规格
                        id: res.positionItems[i].id,
                    })
                }

                this.warehouseInfo = res

            },

            //列表中 选中多行。
            handleSelectionChange(val) {
                console.log("val=", val)
                this.multipleSelection = val
            },

            //删除 ---------------------------------sta
            // 显示 删除对话框
            delDialogOpend(lineNo) {
                // console.log('lineNo=', lineNo)
                this.g_delIndex = lineNo - 1 //记录下点击了 哪一行的删除按钮。

                this.delDialogVisible = true
            },
            // 监听 删除对话框 的关闭事件
            delDialogClosed() {
                this.$refs.delFormRef.resetFields()

            },
            //删除 仓位
            delWarehouse() {
                // console.log('this.g_position_index = ', this.g_position_index)
                // console.log('this.g_delIndex = ', this.g_delIndex)

                if ((this.g_position_index - 2) >= 0) {

                    switch (this.$route.query.type) {
                        case 0: // 新建
                            //新建时候，因为还没通知 后台，直接从缓存删除即可。
                            this.g_warehouseInfo.items.splice(this.g_delIndex, 1) //删除1条记录。
                            break;
                        case 1: // 编辑
                            // bug: 不能直接删除items[X],要设置isDeleted=1。--sta
                            // console.log('this.g_warehouseInfo.items = ', this.g_warehouseInfo.items)
                            // console.log('this.g_warehouseInfo.items_del = ', this.g_warehouseInfo.items_del)

                            this.g_warehouseInfo.items[this.g_delIndex].isDeleted = 1 //先标记为删除。
                            this.g_warehouseInfo.items_del.push(this.g_warehouseInfo.items[this
                                .g_delIndex]) //移动到已删除列表
                            this.g_warehouseInfo.items.splice(this.g_delIndex, 1) //删除1条记录。

                            // console.log('this.g_warehouseInfo.items = ', this.g_warehouseInfo.items)
                            // console.log('this.g_warehouseInfo.items_del = ', this.g_warehouseInfo.items_del)
                            // bug: 不能直接删除items[X],要设置isDeleted=1。--end
                            break;
                        default:
                            break;
                    }

                    this.g_position_index--
                }

                this.delDialogVisible = false

            },
            //删除 ---------------------------------end
        },
        created() {},
        // mounted:html加载完成后执行。执行顺序：子组件-父组件
        mounted() {
            switch (this.$route.query.type) {
                case 1: // 编辑
                    this.getWarehouseInfo(this.$route.query.type, this.$route.query.warehouseId)
                    break;
                case 0: // 新建
                default:
                    break;
            }
        },
        beforeDestroy() {},
        destroyed() {}

    }
</script>

<style lang="scss" scoped>

</style>
